import { makeStyles } from '@material-ui/styles'
import { Theme } from '@material-ui/core'
import { blue, dark50, dark75 } from '../../../lib/Colors'
import Color from 'color'

export default makeStyles(
	(theme: Theme) => ({
		container: {
			flex: 1,
			flexGrow: 1,
			marginRight: 0,
			[theme.breakpoints.up('lg')]: {
				minWidth: 1000,
				width: '100%',
				overflowX: 'hidden',
			},
		},
		subPageContainer: {
			// height: '100vh',
			flex: '1',
		},
		bodyContainer: {
			display: 'flex',
			flexDirection: 'column',
			marginTop: 0,
		},
		title: {
			fontWeight: 600,
			padding: '20px 24px',
			height: '72px',
		},
		listTitle: {
			fontWeight: 600,
			paddingTop: 0,
			fontSize: '20px',
		},
		card: {
			backgroundColor: 'white',
			marginBottom: '8px',
			padding: '10px',
			borderRadius: '6px',
			cursor: 'pointer',
			width: '100%',
		},
		selectedCard: {
			border: `1px solid rgb(200, 200, 200)`,
		},
		rowDivider: {
			width: '1px',
			backgroundColor: 'rgb(233, 234, 236)',
			margin: '0 10px',
		},
		containerWithChip: {
			display: 'flex',
			alignItems: 'center',
			justifyContent: 'space-between',
			paddingLeft: '10px',
			gap: '20px',
		},
		searchContainer: {
			backgroundColor: 'white',
			padding: '12px',
			borderRadius: '6px',
			display: 'flex',
			justifyContent: 'space-between',
			marginBottom: '24px',
		},
		uploadDropzone: {
			backgroundColor: 'rgba(42, 167, 220, 0.1);',
			border: '1px dashed #2AA7DC',
			borderRadius: '6px',
			color: blue,
			display: 'flex',
			alignItems: 'center',
			padding: '24px',
			marginTop: '24px',
			flexDirection: 'column',
			height: '150px',
		},
		uploadRow: {
			display: 'flex',
			alignItems: 'center',
			flexDirection: 'column',
		},
		loadMoreWrap: {
			display: 'flex',
			justifyContent: 'center',
			width: '100%',
			paddingTop: 20,
		},
		infiniteScrollWrap: {
			overflow: 'visible !important',
			display: 'flex',
			flexDirection: 'column',
			flexBasis: '100%',
			flex: 1,
		},
		divider: {
			margin: '0 20px',
			width: '2px',
			height: '100%',
			backgroundColor: 'rgb(233, 234, 236)',
		},
		titleContainer: {
			display: 'flex',
			justifyContent: 'space-between',
			marginBottom: '24px',
		},
		invisibleButton: {
			marginRight: 8,
			'& p': {
				color: dark50,
			},
			'&:hover': {
				backgroundColor: Color(dark75).alpha(0.1).toString(),
				boxShadow: 'none',
				'& p': {
					color: dark75,
				},
			},
			'&:active': {
				backgroundColor: Color(dark75).alpha(0.25).toString(),
				boxShadow: 'none',
				'& p': {
					color: dark75,
				},
			},
		},
		loadingContainer: {
			height: '100%',
			width: '100%',
			display: 'flex',
			justifyContent: 'center',
			alignItems: 'center',
		},
		listContainer: {
			overflowY: 'auto',
		},
	}),
	{ index: 1 },
)
